/** Botão de alternância e faixa de aviso do modo apresentação. */

import { useApresentacao } from '../apresentacao/ModoApresentacao';
import { Icone } from './Icone';

export function BotaoApresentacao() {
  const { ativo, alternar } = useApresentacao();
  return (
    <button
      type="button"
      className={`btn-apresentacao${ativo ? ' ativo' : ''}`}
      onClick={alternar}
      aria-pressed={ativo}
      title={
        ativo
          ? 'Mostrar novamente nomes e retratos (Alt+P)'
          : 'Esconder nomes e retratos para projetar em sessão (Alt+P)'
      }
    >
      <Icone nome={ativo ? 'olhoFechado' : 'olho'} tamanho={16} />
      {ativo ? 'Apresentação ligada' : 'Modo apresentação'}
      <kbd>Alt P</kbd>
    </button>
  );
}

/**
 * Faixa fixa no topo enquanto o modo está ligado.
 *
 * Sem ela é fácil começar a apresentar achando que a máscara está ativa — ou
 * pior, continuar navegando mascarado e achar que os dados sumiram do sistema.
 */
export function FaixaApresentacao() {
  const { ativo, alternar } = useApresentacao();
  if (!ativo) return null;
  return (
    <div className="faixa-apresentacao" role="status">
      <Icone nome="olhoFechado" tamanho={18} />
      <span>
        <strong>Modo apresentação.</strong> Nomes, CIMs e retratos estão borrados. Todos os
        valores continuam visíveis — dá para discutir os números sem identificar ninguém.
      </span>
      <button type="button" className="fa-sair" onClick={alternar}>
        Desligar
      </button>
    </div>
  );
}
